import { BloodPressureValue } from "../challenge/BloodPressureValue";

export const minBloodPressureDefaultGoal: BloodPressureValue = { systolic: 120, diastolic: 60 };
export const maxBloodPressureDefaultGoal: BloodPressureValue = { systolic: 140, diastolic: 80 };

export const minutesInHour = 60;
export const litersInCup = 0.25;
